<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{margin: 0; padding: 0;}
html,body{width: 100%;height: 100%;}
#app {
  width: 100%; height: 100%;
}
.Center{display: flex; justify-content: center; align-items: center; }
.End{display: flex; justify-content: center; align-items: flex-end;}
.Start{display: flex; justify-content: center; align-items: start; }
.LeftCenter{display: flex; justify-content: left; align-items: center; }
.RightCenter{display: flex; justify-content: flex-end; align-items: center; }
.RightTop{display: flex; justify-content: flex-end; align-items: start; }
.RightBottom{display: flex; justify-content: flex-end; align-items: flex-end; }
.LeftTop{display: flex; justify-content: left; align-items: start; }
.LeftBottom{display: flex; justify-content: left; align-items: flex-end; }
.wid100{width: 100%;}
.hei100{height: 100%;}
.logo{width: 92%; margin: 0 auto; height: 5%; position: relative; z-index: 2}
.logo img{width: 42%; }
</style>



// WEBPACK FOOTER //
// src/App.vue